import React from "react"
import Select, { components } from "react-select"
import { Tooltip } from "@mui/material"
import { styled } from "@mui/material/styles"
import { getDescriptionForTag } from "../utils/tagUtils"
import _ from "lodash"

const GroupHeadingContainer = styled("div")`
  color: white;
  background-color: #333;
  &:hover {
    background-color: #444;
  }
  display: flex;
  align-items: center;
  cursor: pointer;
`

class TagSelectFilter extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      collapsedHeaderNames: props.tagOptions.map(
        (tagOption) => tagOption.label
      ),
      inputString: "",
    }
  }

  handleInputChange = (inputString, { action }) => {
    if (action === "input-change") {
      this.setState({ inputString: inputString })
    } else if (action === "set-value") {
      this.setState({ inputString: "" })
    }
  }

  handleMenuClose = () => {
    const allHeaderNames = this.props.tagOptions.map(
      (tagOption) => tagOption.label
    )
    this.setState({ collapsedHeaderNames: allHeaderNames })
  }

  handleGroupHeadingClick = (headerName) => {
    let { collapsedHeaderNames } = this.state
    if (collapsedHeaderNames.includes(headerName)) {
      collapsedHeaderNames = collapsedHeaderNames.filter(
        (collapsedHeaderName) => collapsedHeaderName !== headerName
      )
      this.setState({ collapsedHeaderNames: collapsedHeaderNames })
    } else {
      collapsedHeaderNames.push(headerName)
      this.setState({ collapsedHeaderNames: collapsedHeaderNames })
    }
  }

  getTagGroupForTagName = (tagName) => {
    const { tagOptions } = this.props
    for (const tagGroup of tagOptions) {
      for (const option of tagGroup.options) {
        if (option.value === tagName) {
          return tagGroup.label
        }
      }
    }
  }

  renderTagSelects() {
    const { tagOptions, handleSelectChange, name, selectedOptions } = this.props
    const formatOptionLabel = ({ value, label, description }) => {
      return (
        <div style={{ display: "flex" }}>
          <div
            style={{
              flexBasis: 100,
              flexShrink: 0,
              flexGrow: 0,
              fontWeight: 600,
            }}
          >
            {_.capitalize(label)}
          </div>
          {description && (
            <div
              style={{
                marginLeft: "5px",
                fontSize: "12px",
                fontWeight: 300,
                alignSelf: "center",
              }}
            >
              {`${description}`}
            </div>
          )}
        </div>
      )
    }

    const DropdownIndicator = (props) => {
      return null
    }

    const GroupHeading = (props) => {
      const { collapsedHeaderNames, inputString } = this.state
      const headerName = props.children
      const isBeingSearched = inputString.length > 0
      const arrowClassName =
        collapsedHeaderNames.includes(headerName) && !isBeingSearched
          ? "fas fa-angle-down"
          : "fas fa-angle-up"

      return (
        <GroupHeadingContainer
          onClick={() => this.handleGroupHeadingClick(props.children)}
          aria-expanded={!collapsedHeaderNames.includes(headerName)}
        >
          <components.GroupHeading {...props} style={{ fontSize: "15px" }} />
          <i style={{ fontSize: "12px" }} className={arrowClassName} aria-hidden="true"></i>
        </GroupHeadingContainer>
      )
    }

    const Option = (props) => {
      const tagName = props.value
      const tagGroup = this.getTagGroupForTagName(tagName)
      const { collapsedHeaderNames, inputString } = this.state
      const isBeingSearched = inputString.length > 0
      let shouldShow
      if (collapsedHeaderNames.includes(tagGroup) && !isBeingSearched) {
        shouldShow = false
      } else {
        shouldShow = true
      }
      if (shouldShow) {
        return <components.Option {...props} />
      } else {
        return null
      }
    }

    const MultiValueLabel = (props) => {
      const labelName = _.capitalize(props.data.label)
      const description = getDescriptionForTag(tagOptions, props.data.value)

      if (!_.isEmpty(description)) {
        return (
          <Tooltip
            title={description}
            aria-label={description}
            placement="bottom-start"
          >
            <div>
              <components.MultiValueLabel {...props}>
                {labelName}
              </components.MultiValueLabel>
            </div>
          </Tooltip>
        )
      } else {
        return (
          <components.MultiValueLabel {...props}>
            {labelName}
          </components.MultiValueLabel>
        )
      }
    }

    const customStyles = {
      option: (providedStyles, state) => {
        const optionStyles = {
          ...providedStyles,
          paddingLeft: 30,
        }
        if (!state.isFocused) {
          optionStyles[":nth-of-type(odd):not(:hover)"] = {
            ...providedStyles[":odd"],
            backgroundColor: "#F5F5F5",
          }
        }
        return optionStyles
      },
      groupHeading: (providedStyles, state) => ({
        ...providedStyles,
        fontSize: "110%",
        letterSpacing: "1.2px",
        fontWeight: 300,
        marginBottom: 0,
        padding: "8px 12px",
        color: "white",
        cursor: "pointer",
      }),
      menuList: (providedStyles, state) => ({
        ...providedStyles,
        paddingTop: 0,
      }),
      menu: (providedStyles, state) => ({
        ...providedStyles,
        zIndex: 999,
      }),
      group: (providedStyles, state) => ({
        ...providedStyles,
        padding: 0,
      }),
      input: (providedStyles, state) => ({
        ...providedStyles,
        margin: 0,
        padding: 0,
        minHeight: "50px"
      }),
      control: (provided, state) => ({
        ...provided,
        padding: "0px 0px 0px 10px",
        margin: "3px",
        fontSize: "16px"
      }),
      valueContainer: (provided, state) => ({
        ...provided,
        padding: 0,
      }),
    }

    let maxMenuHeight = this.props.heightOfTagPanel - 140
    if (maxMenuHeight < 300) {
      maxMenuHeight = 300
    }
    const { inputString } = this.state
    const ariaLabel =
      name === "additional_tags"
        ? "Tags to exclude"
        : "Additional tags to filter by"

    return (
      <div>
        <Select
          isMulti
          options={tagOptions}
          formatOptionLabel={formatOptionLabel}
          closeMenuOnSelect={false}
          components={{
            DropdownIndicator,
            MultiValueLabel,
            GroupHeading,
            Option,
          }}
          onChange={handleSelectChange}
          onInputChange={this.handleInputChange}
          onMenuClose={this.handleMenuClose}
          inputValue={inputString}
          menuPlacement={"auto"}
          autoFocus={false}
          styles={customStyles}
          maxMenuHeight={maxMenuHeight}
          placeholder={"Click or search here to add more tag filters"}
          createOptionPosition="first"
          name={name}
          aria-label={ariaLabel}
          value={selectedOptions}
        />
      </div>
    )
  }

  render() {
    return this.renderTagSelects()
  }
}

export default TagSelectFilter
